import { motion } from "framer-motion";
import { ShieldCheck, Globe2, Gem, KeyRound } from "lucide-react";
import { useI18n } from "../context/I18nContext";

const VALUES = [
  { icon: ShieldCheck, t: "why.v1t", x: "why.v1x" },
  { icon: Globe2, t: "why.v2t", x: "why.v2x" },
  { icon: Gem, t: "why.v3t", x: "why.v3x" },
  { icon: KeyRound, t: "why.v4t", x: "why.v4x" },
];

export const WhyUs = () => {
  const { t } = useI18n();
  return (
    <section id="about" data-testid="why-us" className="bg-navy grain relative py-24 md:py-36 px-6 lg:px-10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="font-sans text-gold text-[11px] tracking-luxury uppercase mb-5">
              {t("why.label")}
            </motion.p>
            <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9 }} className="font-serif text-white text-4xl md:text-6xl leading-tight sticky top-32">
              {t("why.hA")} <span className="italic text-gold">{t("why.hB")}</span>
            </motion.h2>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-white/10 border-t border-white/10">
              {VALUES.map((v, i) => (
                <motion.div key={v.t} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.8, delay: i * 0.08 }} className="group py-10 flex items-start gap-6 md:gap-10">
                  <span className="font-serif text-gold/50 text-2xl md:text-3xl w-12 shrink-0 group-hover:text-gold transition-colors">0{i + 1}</span>
                  <div className="shrink-0 mt-1"><v.icon className="w-7 h-7 text-gold" strokeWidth={1.2} /></div>
                  <div>
                    <h3 className="font-serif text-white text-2xl md:text-3xl mb-3">{t(v.t)}</h3>
                    <p className="font-sans text-white/60 text-sm md:text-base max-w-lg leading-relaxed">{t(v.x)}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
